export function isValidFundingFeeEstimate(estimate) {
    if (!/^[A-Z]{3}$/.test(estimate.currency) ||
        !Number.isInteger(estimate.decimals) ||
        estimate.decimals < 0 ||
        estimate.decimals > 4)
        return false;
    const values = [
        estimate.principalUnits,
        estimate.feeUnits,
        estimate.totalUnits,
        ...(estimate.targetUnits === undefined ? [] : [estimate.targetUnits]),
        ...(estimate.receivedLocalUnits === undefined ? [] : [estimate.receivedLocalUnits]),
    ];
    if (!values.every((value) => /^(0|[1-9]\d{0,19})$/.test(value)))
        return false;
    return (BigInt(estimate.principalUnits) + BigInt(estimate.feeUnits) === BigInt(estimate.totalUnits));
}
/** Never render financial rows from a quote belonging to an earlier input revision. */
export function fundingFeeEstimateForAmount(estimate, currency, decimals, amountUnits) {
    return estimate &&
        isValidFundingFeeEstimate(estimate) &&
        estimate.currency === currency &&
        estimate.decimals === decimals &&
        (estimate.targetUnits ?? estimate.principalUnits) === amountUnits
        ? estimate
        : null;
}
